var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "global-feed-container global-feed-timeline" },
    [
      _c("div", { staticClass: "global-feed-title-area" }, [
        _c("div", { staticClass: "global-feed-title" }, [
          _vm._v(_vm._s(_vm.feedTitle)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "global-feed-article-list-area" } },
        _vm._l(_vm.feedItems, function (feedItem, feedIndex) {
          return _c(
            "div",
            {
              staticClass: "global-feed-article-list",
              class: { "global-feed-ad-pure": feedItem.adPure },
              attrs: { id: feedItem.adId },
            },
            [
              !feedItem.ad
                ? _c("feed-item", {
                    attrs: {
                      "feed-param": _vm.feedParam,
                      "feed-item": feedItem,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }